// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookProjectPromoModal_overlay__k80ZP {
  position: fixed;
  inset: 0;
  z-index: 90000;
  background: rgba(0, 0, 0, 0.45);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.BookProjectPromoModal_modal__BLmWF {
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.02), 0 12px 32px -4px rgba(0, 0, 0, 0.14), 0 24px 56px -8px rgba(0, 0, 0, 0.1);
  padding: 32px 28px 24px;
  width: 100%;
  max-width: 440px;
}
.BookProjectPromoModal_modal__BLmWF::before {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: 20px;
  padding: 1px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(29, 78, 216, 0.1) 50%, rgba(59, 130, 246, 0.18) 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  animation: BookProjectPromoModal_borderGlow__PKF8d 3s ease-in-out infinite;
  pointer-events: none;
}

@keyframes BookProjectPromoModal_borderGlow__PKF8d {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
.BookProjectPromoModal_closeButton__dlgRd {
  position: absolute;
  top: 14px;
  right: 14px;
  background: rgba(0, 0, 0, 0.04);
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.BookProjectPromoModal_closeButton__dlgRd:hover {
  background: rgba(0, 0, 0, 0.08);
  color: #374151;
}

.BookProjectPromoModal_iconBadge__H9h9I {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 14px;
  color: white;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3), 0 2px 8px rgba(59, 130, 246, 0.2);
}

.BookProjectPromoModal_title__hMcdD {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
  letter-spacing: -0.02em;
  text-align: center;
}

.BookProjectPromoModal_subtitle__Ze9Ym {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
  text-align: center;
}

.BookProjectPromoModal_mockScreenshot__tmtBW {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.BookProjectPromoModal_mockTitleBar__qisqJ {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f4f6;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  padding: 7px 10px;
}

.BookProjectPromoModal_mockDots__Ymann {
  display: flex;
  gap: 4px;
}
.BookProjectPromoModal_mockDots__Ymann span {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.BookProjectPromoModal_mockDots__Ymann span:nth-child(1) {
  background: #ef4444;
}
.BookProjectPromoModal_mockDots__Ymann span:nth-child(2) {
  background: #f59e0b;
}
.BookProjectPromoModal_mockDots__Ymann span:nth-child(3) {
  background: #22c55e;
}

.BookProjectPromoModal_mockWindowTitle__p43OF {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  flex: 1 1;
  text-align: center;
  padding-right: 36px;
}

.BookProjectPromoModal_mockBody__I7\\+EJ {
  display: flex;
  background: #ffffff;
  height: 116px;
}

.BookProjectPromoModal_mockSidebar__\\+3Baw {
  width: 110px;
  flex-shrink: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  background: #fafafa;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.BookProjectPromoModal_mockSidebarLabel__P2Gi1 {
  font-size: 9px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0 4px 4px;
}

.BookProjectPromoModal_mockChapter__G3yLE {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #6b7280;
  padding: 3px 6px;
  border-radius: 5px;
  cursor: default;
}
.BookProjectPromoModal_mockChapter__G3yLE svg {
  color: #9ca3af;
  flex-shrink: 0;
}

.BookProjectPromoModal_mockChapterActive__H5RmK {
  background: #dbeafe;
  color: #1d4ed8;
  font-weight: 600;
}
.BookProjectPromoModal_mockChapterActive__H5RmK svg {
  color: #3b82f6;
}

.BookProjectPromoModal_mockAddChapter__XXPdU {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #9ca3af;
  padding: 3px 6px;
  margin-top: 2px;
  border-radius: 5px;
  cursor: default;
}

.BookProjectPromoModal_mockContent__Kd3UE {
  flex: 1 1;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BookProjectPromoModal_mockContentTitle__DqkWP {
  font-size: 12px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
}

.BookProjectPromoModal_mockLine__QXSZL {
  height: 7px;
  background: #e5e7eb;
  border-radius: 4px;
}

.BookProjectPromoModal_features__U56uT {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.BookProjectPromoModal_feature__xTMRR {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #374151;
  line-height: 1.4;
}

.BookProjectPromoModal_featureIcon__OmMZF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  background: #dbeafe;
  border-radius: 7px;
  color: #3b82f6;
}

.BookProjectPromoModal_ctaButton__Pt6jY {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 24px;
  background: linear-gradient(180deg, #3b82f6 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms ease-out;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 1px 2px 0px, rgba(0, 0, 0, 0.16) 0px 4px 4px 0px, rgba(0, 0, 0, 0.09) 0px 9px 5px 0px, rgba(0, 0, 0, 0.03) 0px 16px 6px 0px;
}
.BookProjectPromoModal_ctaButton__Pt6jY:hover:not(:disabled) {
  background: linear-gradient(180deg, #2563eb 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px 0px, rgba(59, 130, 246, 0.35) 0px 8px 20px 0px;
}
.BookProjectPromoModal_ctaButton__Pt6jY:active:not(:disabled) {
  transform: translateY(0);
}
.BookProjectPromoModal_ctaButton__Pt6jY:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.BookProjectPromoModal_dismissLink__4Pl0P {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 8px;
  background: none;
  border: none;
  font-size: 13px;
  color: #9ca3af;
  cursor: pointer;
  text-align: center;
  transition: color 0.15s ease;
}
.BookProjectPromoModal_dismissLink__4Pl0P:hover {
  color: #6b7280;
}

@media (max-width: 480px) {
  .BookProjectPromoModal_modal__BLmWF {
    padding: 28px 20px 20px;
    border-radius: 16px;
  }
  .BookProjectPromoModal_title__hMcdD {
    font-size: 18px;
  }
  .BookProjectPromoModal_mockScreenshot__tmtBW {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BookProjectPromoModal/BookProjectPromoModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,6DAAA;EACA,qCAAA;EACA,mBAAA;EACA,oHACE;EAGF,uBAAA;EACA,WAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,2HAAA;EAKA,8EACE;EAEF,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,0EAAA;EACA,oBAAA;AARJ;;AAYA;EACE;IAAW,UAAA;EARX;EASA;IAAM,UAAA;EANN;AACF;AAQA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AANF;AAQE;EACE,+BAAA;EACA,cAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,mBAAA;EACA,YAAA;EACA,iFACE;AARJ;;AAYA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AATF;;AAcA;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,4CAAA;EACA,iBAAA;AAXF;;AAcA;EACE,aAAA;EACA,QAAA;AAXF;AAaE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAXJ;AAaI;EAAiB,mBAAA;AAVrB;AAWI;EAAiB,mBAAA;AARrB;AASI;EAAiB,mBAAA;AANrB;;AAUA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAPF;;AAUA;EACE,YAAA;EACA,cAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAPF;;AAUA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAPF;AASE;EACE,cAAA;EACA,cAAA;AAPJ;;AAWA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AARF;AAUE;EACE,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AATF;;AAYA;EACE,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AATF;;AAYA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;AATF;;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAXF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,6DAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,+JACE;AAdJ;AAmBE;EACE,6DAAA;EACA,2BAAA;EACA,0FACE;AAlBN;AAsBE;EACE,wBAAA;AApBJ;AAuBE;EACE,YAAA;EACA,mBAAA;AArBJ;;AAyBA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;AAtBF;AAwBE;EACE,cAAA;AAtBJ;;AA4BA;EACE;IACE,uBAAA;IACA,mBAAA;EAzBF;EA4BA;IACE,eAAA;EA1BF;EA6BA;IACE,aAAA;EA3BF;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 90000;\n  background: rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.modal {\n  position: relative;\n  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 20px;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.02),\n    0 12px 32px -4px rgba(0, 0, 0, 0.14),\n    0 24px 56px -8px rgba(0, 0, 0, 0.1);\n  padding: 32px 28px 24px;\n  width: 100%;\n  max-width: 440px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: -1px;\n    border-radius: 20px;\n    padding: 1px;\n    background: linear-gradient(135deg,\n      rgba(59, 130, 246, 0.18) 0%,\n      rgba(29, 78, 216, 0.1) 50%,\n      rgba(59, 130, 246, 0.18) 100%\n    );\n    -webkit-mask:\n      linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    opacity: 0;\n    animation: borderGlow 3s ease-in-out infinite;\n    pointer-events: none;\n  }\n}\n\n@keyframes borderGlow {\n  0%, 100% { opacity: 0; }\n  50% { opacity: 1; }\n}\n\n.closeButton {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  background: rgba(0, 0, 0, 0.04);\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.08);\n    color: #374151;\n  }\n}\n\n.iconBadge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 16px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  border-radius: 14px;\n  color: white;\n  box-shadow:\n    0 6px 20px rgba(59, 130, 246, 0.3),\n    0 2px 8px rgba(59, 130, 246, 0.2);\n}\n\n.title {\n  margin: 0 0 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n  text-align: center;\n}\n\n.subtitle {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #6b7280;\n  text-align: center;\n}\n\n// ── Mock Screenshot ──────────────────────────────────────\n\n.mockScreenshot {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.mockTitleBar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f3f4f6;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.07);\n  padding: 7px 10px;\n}\n\n.mockDots {\n  display: flex;\n  gap: 4px;\n\n  span {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n\n    &:nth-child(1) { background: #ef4444; }\n    &:nth-child(2) { background: #f59e0b; }\n    &:nth-child(3) { background: #22c55e; }\n  }\n}\n\n.mockWindowTitle {\n  font-size: 11px;\n  color: #9ca3af;\n  font-weight: 500;\n  flex: 1;\n  text-align: center;\n  padding-right: 36px; // offset for dots width\n}\n\n.mockBody {\n  display: flex;\n  background: #ffffff;\n  height: 116px;\n}\n\n.mockSidebar {\n  width: 110px;\n  flex-shrink: 0;\n  border-right: 1px solid rgba(0, 0, 0, 0.07);\n  background: #fafafa;\n  padding: 8px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mockSidebarLabel {\n  font-size: 9px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 0 4px 4px;\n}\n\n.mockChapter {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #6b7280;\n  padding: 3px 6px;\n  border-radius: 5px;\n  cursor: default;\n\n  svg {\n    color: #9ca3af;\n    flex-shrink: 0;\n  }\n}\n\n.mockChapterActive {\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-weight: 600;\n\n  svg {\n    color: #3b82f6;\n  }\n}\n\n.mockAddChapter {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  color: #9ca3af;\n  padding: 3px 6px;\n  margin-top: 2px;\n  border-radius: 5px;\n  cursor: default;\n}\n\n.mockContent {\n  flex: 1;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mockContentTitle {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.mockLine {\n  height: 7px;\n  background: #e5e7eb;\n  border-radius: 4px;\n}\n\n// ── Features ─────────────────────────────────────────────\n\n.features {\n  list-style: none;\n  margin: 0 0 20px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.feature {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.featureIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n  background: #dbeafe;\n  border-radius: 7px;\n  color: #3b82f6;\n}\n\n// ── Actions ──────────────────────────────────────────────\n\n.ctaButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 13px 24px;\n  background: linear-gradient(180deg, #3b82f6 0%, #1d4ed8 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 150ms ease-out;\n  box-shadow:\n    rgba(0, 0, 0, 0.18) 0px 1px 2px 0px,\n    rgba(0, 0, 0, 0.16) 0px 4px 4px 0px,\n    rgba(0, 0, 0, 0.09) 0px 9px 5px 0px,\n    rgba(0, 0, 0, 0.03) 0px 16px 6px 0px;\n\n  &:hover:not(:disabled) {\n    background: linear-gradient(180deg, #2563eb 0%, #1e40af 100%);\n    transform: translateY(-1px);\n    box-shadow:\n      rgba(0, 0, 0, 0.18) 0px 2px 4px 0px,\n      rgba(59, 130, 246, 0.35) 0px 8px 20px 0px;\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n}\n\n.dismissLink {\n  display: block;\n  width: 100%;\n  margin-top: 10px;\n  padding: 8px;\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: #9ca3af;\n  cursor: pointer;\n  text-align: center;\n  transition: color 0.15s ease;\n\n  &:hover {\n    color: #6b7280;\n  }\n}\n\n// ── Mobile ───────────────────────────────────────────────\n\n@media (max-width: 480px) {\n  .modal {\n    padding: 28px 20px 20px;\n    border-radius: 16px;\n  }\n\n  .title {\n    font-size: 18px;\n  }\n\n  .mockScreenshot {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `BookProjectPromoModal_overlay__k80ZP`,
	"modal": `BookProjectPromoModal_modal__BLmWF`,
	"borderGlow": `BookProjectPromoModal_borderGlow__PKF8d`,
	"closeButton": `BookProjectPromoModal_closeButton__dlgRd`,
	"iconBadge": `BookProjectPromoModal_iconBadge__H9h9I`,
	"title": `BookProjectPromoModal_title__hMcdD`,
	"subtitle": `BookProjectPromoModal_subtitle__Ze9Ym`,
	"mockScreenshot": `BookProjectPromoModal_mockScreenshot__tmtBW`,
	"mockTitleBar": `BookProjectPromoModal_mockTitleBar__qisqJ`,
	"mockDots": `BookProjectPromoModal_mockDots__Ymann`,
	"mockWindowTitle": `BookProjectPromoModal_mockWindowTitle__p43OF`,
	"mockBody": `BookProjectPromoModal_mockBody__I7+EJ`,
	"mockSidebar": `BookProjectPromoModal_mockSidebar__+3Baw`,
	"mockSidebarLabel": `BookProjectPromoModal_mockSidebarLabel__P2Gi1`,
	"mockChapter": `BookProjectPromoModal_mockChapter__G3yLE`,
	"mockChapterActive": `BookProjectPromoModal_mockChapterActive__H5RmK`,
	"mockAddChapter": `BookProjectPromoModal_mockAddChapter__XXPdU`,
	"mockContent": `BookProjectPromoModal_mockContent__Kd3UE`,
	"mockContentTitle": `BookProjectPromoModal_mockContentTitle__DqkWP`,
	"mockLine": `BookProjectPromoModal_mockLine__QXSZL`,
	"features": `BookProjectPromoModal_features__U56uT`,
	"feature": `BookProjectPromoModal_feature__xTMRR`,
	"featureIcon": `BookProjectPromoModal_featureIcon__OmMZF`,
	"ctaButton": `BookProjectPromoModal_ctaButton__Pt6jY`,
	"dismissLink": `BookProjectPromoModal_dismissLink__4Pl0P`
};
export default ___CSS_LOADER_EXPORT___;
